window.cloneCart = window.cloneCart || function cloneCart() {
  const cartTotal = document.getElementById('cartSubTotal');
  const cartNav = document.getElementById('cartNav');

  if (!cartTotal || !cartNav) return;

  const clonedCart = cartTotal.cloneNode(true);
  clonedCart.id = 'sticky_headerTotal';
  cartNav.replaceChildren(clonedCart);

  document.querySelectorAll('tr.cart-item').forEach((cartItem) => {
    const dataId = cartItem.getAttribute('data-id');
    if (!dataId) return;

    const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);
    if (drawerFooter) drawerFooter.classList.add('Gift-Wrapper__hide');
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE') return;

      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    window.setTimeout(() => this.classList.add('animate', 'active'));

    this.addEventListener('transitionend', () => {
      const focusContainer = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

      if (focusContainer && focusElement) trapFocus(focusContainer, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    window.cloneCart();
  }

  close() {
    this.classList.remove('active');
    if (this.activeElement) removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    window.cloneCart();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    const content = cartDrawerNote.nextElementSibling;
    if (content?.id) cartDrawerNote.setAttribute('aria-controls', content.id);

    cartDrawerNote.addEventListener('click', (event) => {
      const details = event.currentTarget.closest('details');
      event.currentTarget.setAttribute('aria-expanded', details ? !details.hasAttribute('open') : 'false');
    });

    cartDrawerNote.parentElement?.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState?.sections) {
      console.error('Cart section response is missing.');
      return;
    }

    const drawerInner = this.querySelector('.drawer__inner');
    drawerInner?.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections[section.id];
      if (!sectionHtml) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;

      const sectionInnerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (sectionInnerHtml === null) return;

      sectionElement.innerHTML = sectionInnerHtml;
    });

    window.cloneCart();

    window.setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedDocument.querySelector(selector);

    return selectedElement ? selectedElement.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'header-total' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'header-total', section: 'header-total', selector: '.total-sub' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}

document.addEventListener('change', (event) => {
  if (event.target.id === 'CartDrawer-Note') {
    updateCart({ note: event.target.value }, 'Order note updated');
  }

  if (event.target.id === 'CartDrawer-DiscountCode') {
    const discountCode = event.target.value;
    if (discountCode) {
      applyDiscountCode(discountCode);
    } else {
      removeDiscountCode();
    }
  }
});

function updateCart(data, successMessage) {
  const request = new XMLHttpRequest();
  request.open('POST', '/cart/update.js', true);
  request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

  request.onload = function onLoad() {
    if (request.status >= 200 && request.status < 400) {
      console.log(successMessage, JSON.parse(request.responseText));
    } else {
      console.error('Error updating cart:', request.statusText);
    }
  };

  request.onerror = function onError() {
    console.error('Error updating cart:', request.statusText);
  };

  request.send(JSON.stringify(data));
}

function applyDiscountCode(discountCode) {
  const request = new XMLHttpRequest();
  request.open('POST', '/cart.js', true);
  request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

  request.onload = function onLoad() {
    if (request.status >= 200 && request.status < 400) {
      const cart = JSON.parse(request.responseText);
      console.log('Discount code applied:', cart.discount_code);
    } else {
      console.error('Error applying discount code:', request.statusText);
    }
  };

  request.onerror = function onError() {
    console.error('Error applying discount code:', request.statusText);
  };

  request.send(JSON.stringify({ attributes: { _discount_code: discountCode } }));
}

function removeDiscountCode() {
  const request = new XMLHttpRequest();
  request.open('POST', '/cart/update.js', true);
  request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

  request.onload = function onLoad() {
    if (request.status >= 200 && request.status < 400) {
      const cart = JSON.parse(request.responseText);
      console.log('Discount code removed:', cart.discount_code);
    } else {
      console.error('Error removing discount code:', request.statusText);
    }
  };

  request.onerror = function onError() {
    console.error('Error removing discount code:', request.statusText);
  };

  request.send(JSON.stringify({ attributes: { _discount_code: '' } }));
}
